/**
 * 生成基础axios对象，并对请求和响应做处理
 * 前后端约定接口返回解构规范
 * {
 *    code:200,
 *    data:"",
 *    message:""
 * }
 */
import axios from 'axios'

// 创建一个独立的axios实例
const service = axios.create({
  baseURL: '', // 设置后端API基础URL
  // headers: {},// 定义统一的请求头部
  // withCredentials: true, // 跨域请求时发送cookies
  timeout: 60000 // 请求超时时间改为60秒
})

// token 请求白名单,请求后台时不需要传token的接口地址
// const writeList = ['/customer/login']

// 请求拦截
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    /* if (!writeList.includes(config.url)) {
      // 让请求携带令牌
      config.headers['Authorization'] = getKey('token')
    } */
    return config
  },
  error => {
    // 处理请求错误
    return Promise.reject(error)
  }
)
// 返回拦截
/* service.interceptors.response.use(
  (response) => {
    // 获取接口返回结果
    const res = response.data
    // code为200，直接把结果返回回去
    if (res.code === 200) {
      return res
    } else {
      Toast.fail(res.message)
      return res
    }
  }, () => {
    Toast.fail('网络请求异常，请稍后重试!')
}) */
export default service
